import React, { createContext, useState, useEffect } from "react";
import api from "../services/api";
import { useNavigate } from "react-router-dom";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    async function loadUserFromStorage() {
      const token = localStorage.getItem("token");
      if (token) {
        try {
          api.defaults.headers.Authorization = `Bearer ${token}`;
          const { data } = await api.get("/auth/me");
          setUser(data);
        } catch (error) {
          const status = error.response?.status;
          console.error(error);
          // Só desloga automaticamente se o token for realmente inválido.
          if (status === 401 || status === 403) {
            localStorage.removeItem("token");
            delete api.defaults.headers.Authorization;
          }
        }
      }
      setLoading(false);
    }
    loadUserFromStorage();
  }, []);

  const login = async (login, senha) => {
    const normalizedLogin = login.includes("@") ? login : login.replace(/\D/g, "");
    const { data } = await api.post("/auth/login", { login: normalizedLogin, senha });
    localStorage.setItem("token", data.token);
    api.defaults.headers.Authorization = `Bearer ${data.token}`;
    const { data: userData } = await api.get("/auth/me");
    setUser(userData);

    // Redirecionamento baseado no perfil
    switch (userData.perfil_id) {
      case 1: // ADMIN
        navigate("/admin/usuarios");
        break;
      case 2: // CONTROLADOR
        navigate("/controlador/editais");
        break;
      default: // USUARIO
        navigate("/editais");
        break;
    }
  };

  const logout = () => {
    localStorage.removeItem("token");
    setUser(null);
    navigate("/");
  };

  return (
    <AuthContext.Provider
      value={{ signed: !!user, user, loading, login, logout, setUser }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
